import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogoLoaderModule } from '@y42/core/logo-loader';
import { GitHardResetButtonModule } from '../../../git/git-hard-reset-button/git-hard-reset-button.module';
import { StatusIndicatorComponent } from './status-indicator.component';

@NgModule({
  imports: [CommonModule, LogoLoaderModule, GitHardResetButtonModule],
  declarations: [StatusIndicatorComponent],
  exports: [StatusIndicatorComponent],
})
export class StatusIndicatorModule {}
